import { useEffect, useMemo, useState } from "react";

import { useSite } from "../utils";

import Source from "./Source";

export default function Previewer({ show, url, pageId, params }) {
  const { siteId, hasCms } = useSite()
  const data = useMemo(() => ({ ...params, pageId, siteId }), [params, pageId, siteId])

  const [, setTimeoutId] = useState(null)
  const [status, setStatus] = useState(STATUS.LOADING)

  useEffect(() => {
    setStatus(STATUS.LOADING)

    const newTimeout = setTimeout(() => {
      setStatus(status => {
        if (status === STATUS.LOADED) {
          return status
        }
        return STATUS.FAILED
      })
    }, 10000)

    setTimeoutId(timeout => {
      if (timeout) {
        clearTimeout(timeout)
      }
      return newTimeout
    })

    return () => clearTimeout(newTimeout)
  }, [url, setStatus])

  if (!show) {
    return null
  }

  if (status === STATUS.FAILED) {
    return <div className="flex justify-center items-center py-8 text-lg border twy-border-base">
      <span>Reload blocked. Check your page settings.</span>
    </div>
  }

  if (hasCms) {
    return <Frame _key={url}>
      <iframe src={url} className="m-0 p-0 border-0" width="100%" height="620px"
        sandbox="allow-scripts allow-same-origin" onLoad={() => setStatus(STATUS.LOADED)}></iframe>
    </Frame>
  }

  return <Frame _key={url}>
    <Source data={data} onLoad={() => setStatus(STATUS.LOADED)} />
  </Frame>
}

function Frame({ _key, children }) {
  return <pre key={_key} className="formBuilder__builder m-0 p-0 border border-1" style={{ maxHeight: "620px" }}>
    {children}
  </pre>
}

const STATUS = {
  LOADING: 'LOADING',
  LOADED: 'LOADED',
  FAILED: 'FAILED',
}
